import React from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";

const DashboardCard = ({ cardData, dateFrom, dateTo, locValue }) => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const handleNavigate = (card) => {
    switch (("card", card?.title)) {
      case "Completed Trips":
        return navigate("/operation/allrides/completed", {
          state: { value: "completed", dateFrom, dateTo, fromTab: "dashboard" },
        });
      case "Ongoing Trips":
        return navigate("/reservation", {
          state: { value: "onGoing", dateFrom, dateTo, fromTab: "dashboard" },
        });
      case "Booked Trips":
        return navigate("/operation/allrides/booked", {
          state: { value: "booked", dateFrom, dateTo, fromTab: "dashboard" },
        });
      case "Cancelled Trips":
        return navigate("/operation/allrides/cancelled", {
          state: { value: "cancelled", dateFrom, dateTo, fromTab: "dashboard" },
        });
      case "Active Drivers":
        return navigate("/driver", {
          state: {
            driverStatus: "Active",
            companyType: role,
            dateFrom,
            dateTo,
            fromTab: "dashboard",
          },
        });
      case "Active Sub-Vendors":
        return navigate("/sub-vendor", {
          state: {
            subVendorStatus: "Active",
            companyType: role,
            dateFrom,
            dateTo,
            fromTab: "dashboard",
          },
        });
      case "Companies":
        return navigate(
          `/company?location=${locValue?.name ? locValue?.name : ""}`
        );
      case "Revenue":
        return navigate("/report/revenue", {
          state: { dateFrom, dateTo, fromTab: "dashboard" },
        });
      default:
        return navigate(card.path);
    }
  };

  return (
    <Grid container justifyContent='space-between'>
      {cardData &&
        cardData.map((card, index) => (
          <Grid
            item
            key={index}
            xs={12}
            md={2.2}
            className="dashboardCards p20"
            // TODO: commenting as we need 2 dashboard
            // onClick={() => handleNavigate(card)}
          >
            <Typography className="colorBlack pb10">{card.title}</Typography>
            <Typography className="colorBlack font20 fw600">
              {card.subTitle}
            </Typography>
          </Grid>
        ))}
    </Grid>
  );
};

export default DashboardCard;
